import React from "react";
import DynamicHeader from "components/GlobalComponents/DynamicHeader/DynamicHeader";
import { Row, Col } from "antd";
import "./Kontakte.scss";
import { SocialLinks } from "components/GlobalComponents/SocialLinks/SocialLinks";
import { Cards } from "components/GlobalComponents/Cards/Cards";

export const Kontakte = () => {
  return (
    <>
      <DynamicHeader title={"Kontakte"} />
      <div className="contacts-wrapper">
        <Row className="contacts-content">
          <div className="contacts-details">
            <b>Lorem ipsum</b>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industrys standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book. It has
              survived not only five centuries, but also the leap into
              electronic typesetting, remaining essentially unchanged. It was
              popularised in the 1960s with the release of Letraset sheets
              containing Lorem Ipsum passages, and more recently with desktop
              publishing software like Aldus PageMaker including versions of
              Lorem Ipsum.
            </p>
            <SocialLinks />
          </div>
          <Col className="contact-card-wrapper">
            <Cards
              {...{
                title: "test",
                description: "test",
                imgUrl:
                  "https://os.alipayobjects.com/rmsportal/QBnOOoLaAfKPirc.png",
              }}
            />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Kontakte;
